
export const COLORS = {
    PRIMARY_BLUE: '#003366',      // Azul Marinho/Profundo para identidade (Status Agendamento)
    SUCCESS_GREEN: '#00A896',     // Verde Esmeralda para status "Disponível"
    ACTION_BLUE: '#3B82F6',       // Azul vibrante para botões, links e UI ativa
    NEUTRAL_GRAY: '#4A4A4A',      // Cinza Carvão para texto e ícones inativos
    WHITE: '#FFFFFF',
    LIGHT_GRAY: '#F7F7F7',
};

export const USERS_COLLECTION = 'users';
export const CHATS_COLLECTION = 'chats';
export const PROPOSALS_COLLECTION = 'proposals';
export const NOTIFICATIONS_COLLECTION = 'notifications'; // Adicionado
export const APPOINTMENTS_COLLECTION = 'appointments';
export const SERVICE_REQUESTS_COLLECTION = 'serviceRequests';
